import {Component} from 'react'

import './Moderations.scss'

export default class ModerationsLoading extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-12">
          <table className="table table-striped table-dark w-100">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Modérateur</th>
                <th scope="col">Description</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">...</th>
                <td>...</td>
                <td>...</td>
                <td>...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}